import { useQuery as useReactQuery } from "@tanstack/react-query";
import type { WhisperJson } from "@teksta/shared-types";
import destr from "destr";
import { ofetch } from "ofetch";
import { hasWordTimings } from "subtitletools";
import { getPublicBucketBaseUrl } from "../storage";

export const getHasWordTimestamps = (whisperJson: WhisperJson) =>
  hasWordTimings(whisperJson.segments);

export const getHasSpeakers = (whisperJson: WhisperJson | undefined) => {
  const hasSpeakers = !whisperJson?.segments.some((segment) => !segment.speaker);

  return hasSpeakers;
};

export const useWhisperJson = ({
  transcriptionRun,
}: {
  transcriptionRun?: Exclude<
    GQL_TRANSCRIPTION_CONTENT_SUBSCRIPTION["transcription_jobs_by_pk"],
    null
  >["transcription_runs"][0];
}) => {
  const runId = transcriptionRun?.id;
  const textIsReady = transcriptionRun?.text_status === "READY";

  const { data: whisperJson } = useReactQuery({
    enabled: !!runId && textIsReady,
    queryKey: [`${runId}-whisper_data`],
    retry: 12,
    queryFn: async () => {
      const response = ofetch<WhisperJson>(
        `${getPublicBucketBaseUrl()}/transcription_runs/${runId}/whisper_data.json`,
        { parseResponse: destr<WhisperJson> }
      );
      return response;
    },
  });

  // Keep canonical IDs for speaker editing. Previews/exports resolve display names.
  return whisperJson;
};
